import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-reset-password',
  templateUrl: './modal-reset-password.component.html',
  styleUrls: ['./modal-reset-password.component.scss']
})
export class ModalResetPasswordComponent implements OnInit, OnDestroy {
  @Input() userInfos;
  @Input() resetOperador;
  resetPasswordForm: UntypedFormGroup = new UntypedFormGroup({
    old_password: new UntypedFormControl("", Validators.required),
    new_password: new UntypedFormControl("", Validators.required),
    confirm_password: new UntypedFormControl("", Validators.required)
  });
  strength = 0;
  strengthText = "";
  passwords_type = {
    old: 'password',
    new: 'password',
    confirm: 'password'
  };
  newSubs: Subscription;
  nova_senha_gerada: any;

  constructor(
    private modal: NgbActiveModal,
    private translate: TranslateService,
    private loginService: LoginService,
    private toastr: ToastrService,
    private usuariosService: UsuariosService
  ) {}

  ngOnInit(): void {
    if(this.resetOperador) {
      this.geraNovaSenhaOperador();
    }
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  close(results?): void {
    this.modal.close(results);
  }

  geraNovaSenhaOperador(): void {
    this.newSubs = this.usuariosService.resetarSenhaOperador(this.resetOperador)
      .subscribe({
        next: (results) => {
          this.nova_senha_gerada = results.password;
        }
      });
  }

  passwordStrength() {
    var password = this.resetPasswordForm.value.new_password;
    var password_strength = 0;
    
    if ((password.length >= 8) && (password.length < 12)) {
      password_strength += 30;
    } else if (password.length >= 12) {
      password_strength += 40;
    }
    
    if (password.match(/[a-z]+/)) { //Verifica letras minusculas
      password_strength += 10;
    }
    
    if (password.match(/[A-Z]+/)) { //verifica letras maiusculas
      password_strength += 15;
    }
    
    if (password.match(/[0-9]+/)) { // verifica se tem numeros
      password_strength += 15;
    }
    
    if (password.match(/["!#$%&'()*+,-./:;?@[\\\]_`{|}~=§º<>ª]+/)) { //verifica se tem caracteres especiais
      password_strength += 20;
    }
    
    this.strength = password_strength;
    this.passwordClassification(this.strength);
  }

  passwordClassification(strength) {
    if (strength < 30) {
      this.strengthText = this.translate.instant("FRACA");
    } else if ((strength >= 30) && (strength <= 75)) {
      this.strengthText = this.translate.instant("MEDIA");
    } else if ((strength > 75) && (strength < 99)) {
      this.strengthText = this.translate.instant("BOA");
    } else {
      this.strengthText = this.translate.instant("EXCELENTE");
    }
  }

  changePassView(type): void {
    switch(type) {
      case 1:
        this.passwords_type.old = (this.passwords_type.old === 'password') ? 'text' : 'password';
        break;
      case 2:
        this.passwords_type.new = (this.passwords_type.new === 'password') ? 'text' : 'password';
        break;
      case 3:
        this.passwords_type.confirm = (this.passwords_type.confirm === 'password') ? 'text' : 'password';
        break;
    }
  }

  verifyDisabled(): boolean {
    if(this.resetPasswordForm.invalid || this.strength < 90) {
      return true;
    } else if(this.resetPasswordForm.value.confirm_password !== this.resetPasswordForm.value.new_password) {
      return true;
    } else {
      return false;
    }
  }

  submitNewPassword(passwordValues): void {
    let _payload = {
      email: this.userInfos.email,
      senha_atual: passwordValues.old_password,
      nova_senha: passwordValues.new_password,
      confirma_nova_senha: passwordValues.confirm_password
    };

    this.newSubs = this.loginService.resetPassword(_payload)
      .subscribe({
        next: (results) => {
          this.modal.close(true);
        }
      });
  }

  copyToClipboard(valor): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = valor;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.show(this.translate.instant('COPIADO_SUCESSO'), "", environment.toastrConfig("success"));
  }
}
